import { useMemo } from 'react'
import { useVerificationRequestStatusQuery } from './queries/useVerificationRequestStatusQuery'
import { useAccountsQuery, useProfileQuery } from './queries'
import { BUSINESS_VERIFIED } from 'utils/auth/utils'
import { AccountTypes } from 'types/types'
import { AccountType } from 'types/accounts'

export const useRequestsOnLogin = () => {
  const {
    data: profile,
    isFetching: isFetchingProfile,
    isFetched: isFetchedProfile,
  } = useProfileQuery()

  const {
    data: accounts,
    isFetching: isFetchingAccounts,
    isFetched: isFetchedAccounts,
  } = useAccountsQuery(isFetchedProfile)

  const currentAccount: AccountType = accounts?.find(account => account?.isCurrent)

  const {
    data: verificationRequestStatus,
    isFetching: isFetchingVerificationRequestStatus,
    isFetched: isFetchedVerificationRequestStatus,
  } = useVerificationRequestStatusQuery(isFetchedProfile)

  const isVerifiedBusinessAccount = useMemo(
    () => verificationRequestStatus === BUSINESS_VERIFIED,
    [verificationRequestStatus]
  )

  const isDeveloperAccount = useMemo(
    () => profile?.options?.registrationAccountType === AccountTypes.DEVELOPER,
    [profile?.options?.registrationAccountType]
  )

  const isAuthorizedAccount = useMemo(
    () => isVerifiedBusinessAccount || isDeveloperAccount,
    [isVerifiedBusinessAccount, isDeveloperAccount]
  )

  const isLoadingRequestsOnLogin = useMemo(
    () => isFetchingProfile || isFetchingVerificationRequestStatus || isFetchingAccounts,
    [isFetchingProfile, isFetchingVerificationRequestStatus, isFetchingAccounts]
  )

  const fetchedRequest = {
    profile: isFetchedProfile,
    verification: isFetchedVerificationRequestStatus,
    account: isFetchedAccounts,
  }

  return {
    isLoadingRequestsOnLogin,
    fetchedRequest,
    profile,
    isVerifiedBusinessAccount,
    isDeveloperAccount,
    isAuthorizedAccount,
    accounts,
    currentAccount,
  }
}
